import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import useGetDataUser from "../../../../utilidades/customHooks/useGetDataUser";
import { formatearFecha } from "../../../../utilidades/formateos";
import { addTickets, getTickets } from "../integracion";

const ModalNuevo = ({
    visible,
    onHide,
    filtros,
    setDatos,
    operadores,
    administrativos,
    gasolineras,
    combistibles
   
}) => {
    const [ticket, setTicket] = useState({
        fecha: new Date(),
        hora: "",
        unidad: null,
        tipo: "operador", // operador | administrativo
        operador: null,
        administrativo: null,
        gasolinera: null,
        folio: null,
        kilometraje: null,
        tipoConsumible: null,
        litros: null,

    });
    const dataUser = useGetDataUser()
    const handleChange = (campo, valor) => {
        setTicket({ ...ticket, [campo]: valor });
    };
    const subirTicket = async (data) => {
        if (
            ticket.fecha &&
            ticket.hora &&
            ticket.unidad &&
            (ticket.tipo == 'operador' ? ticket.operador : ticket.administrativo) &&
            ticket.gasolinera &&
            ticket.folio &&
            ticket.kilometraje &&
            ticket.tipoConsumible &&
            ticket.litros
        ) {
            const data = {
                fecha: formatearFecha(ticket.fecha),
                hora: ticket.hora + ':00',
                id_unidad: ticket.unidad,
                id_gasolinera: ticket.gasolinera.code,
                folio: ticket.folio,
                kilometraje: ticket.kilometraje,
                tipo_combustible: ticket.tipoConsumible.name,
                litros: ticket.litros,
                // precio: precioCrear,
                id_operador: ticket.tipo == 'operador' ? ticket.operador.code : ticket.administrativo.code,
                tipo_colaborador: ticket.tipo,
                nota: '--Ticket creado por : ' + dataUser.user.NOMBRE + ' --',

            }
            await addTickets(data, onHide, limpiar)
            await getTickets(filtros, setDatos)
            console.log("ticket", data);
        }
        else {
            Swal.fire({
                icon: 'error',
                text: 'Faltan campos por llenar'
            })
        }

    }
    const limpiar = () => {
        setTicket({
            fecha: new Date(),
            hora: "",
            unidad: null,
            tipo: "operador", // operador | administrativo
            operador: null,
            administrativo: null,
            gasolinera: null,
            folio: null,
            kilometraje: null,
            tipoConsumible: null,
            litros: null,

        })
    }
    const footer = (
        <div className="footer-modal">
            <Button label="Cancelar" icon="pi pi-times" severity="secondary" onClick={onHide} />
            <Button label="Guardar" icon="pi pi-check" severity="success" onClick={() => subirTicket(ticket)} />
        </div>
    );


    return (
        <Dialog header="Nuevo Ticket" visible={visible} onHide={onHide} footer={footer} modal className="modal-editar-ticket" style={{ width: "40rem" }}>
            <div className="formulario-modal">
                <div className="grupo-filtro">
                    <label>Fecha</label>
                    <Calendar value={ticket.fecha} onChange={(e) => handleChange("fecha", e.value)} className="w-full" showIcon dateFormat="dd/mm/yy" />
                </div>

                <div className="grupo-filtro">
                    <label>Hora</label>
                    <input type="time" className="w-full p-inputtext" value={ticket.hora} onChange={(e) => handleChange("hora", e.target.value)} />
                </div>

                <div className="grupo-filtro">
                    <label>Unidad</label>
                    <InputNumber  useGrouping={false} value={ticket.unidad} onValueChange={(e) => handleChange("unidad", e.value)} inputClassName="w-full" />
                </div>

                <div className="grupo-filtro">
                    <label>Tipo</label>
                    <div className="flex gap-3">
                        <div>
                            <RadioButton inputId="tipo1" name="tipo" value="operador" onChange={(e) => handleChange("tipo", e.value)} checked={ticket.tipo === "operador"} />
                            <label htmlFor="tipo1" className="ml-2">Operador</label>
                        </div>
                        <div>
                            <RadioButton inputId="tipo2" name="tipo" value="administrativo" onChange={(e) => handleChange("tipo", e.value)} checked={ticket.tipo === "administrativo"} />
                            <label htmlFor="tipo2" className="ml-2">Administrativo</label>
                        </div>
                    </div>
                </div>

                {ticket.tipo === "operador" ? (
                    <div className="grupo-filtro">
                        <label>Operador</label>
                        <Dropdown filter value={ticket.operador} onChange={(e) => handleChange("operador", e.value)} options={operadores} placeholder="Seleccionar operador" className="w-full" optionLabel="name" />
                    </div>
                ) : (
                    <div className="grupo-filtro">
                        <label>Administrativo</label>
                        <Dropdown filter value={ticket.administrativo} onChange={(e) => handleChange("administrativo", e.value)} options={administrativos} placeholder="Seleccionar administrativo" className="w-full" optionLabel="name" />
                    </div>
                )}

                <div className="grupo-filtro">
                    <label>Gasolinera</label>
                    <Dropdown filter value={ticket.gasolinera} onChange={(e) => handleChange("gasolinera", e.value)} options={gasolineras} placeholder="Gasolinera" className="w-full" optionLabel="name" />
                </div>

                <div className="grupo-filtro">
                    <label>Folio</label>
                    <InputNumber  useGrouping={false} value={ticket.folio} onValueChange={(e) => handleChange("folio", e.value)} inputClassName="w-full" />
                </div>

                <div className="grupo-filtro">
                    <label>Kilometraje</label>
                    <InputNumber  useGrouping={false} value={ticket.kilometraje} onValueChange={(e) => handleChange("kilometraje", e.value)} inputClassName="w-full" />
                </div>

                <div className="grupo-filtro">
                    <label>Tipo consumible</label>
                    <Dropdown filter value={ticket.tipoConsumible} onChange={(e) => handleChange("tipoConsumible", e.value)} options={combistibles} placeholder="Consumible" className="w-full" optionLabel="name" />
                </div>

                <div className="grupo-filtro">
                    <label>Litros</label>
                    <InputNumber  useGrouping={false} value={ticket.litros} onValueChange={(e) => handleChange("litros", e.value)} inputClassName="w-full" />
                </div>
            </div>
        </Dialog>
    );
};

export default ModalNuevo;
